<template>
  <component
    v-if="component"
    :is="component"
    :payment-type="paymentType"
    :order-id="orderId"
    :deliveryServiceId="deliveryServiceId"
    :mode="mode"
    :options="options"
    :smartCart="smartCart"
    :selected="selected"
    @selectPaymentAuth="onSelectPaymentAuth"
  />
</template>
<script>
import gateway from "~/mixins/gateway";
export default {
  name: "GatewayWriter",
  mixins: [gateway],
  props: {
    componentName: { type: String, required: true },
    smartCart: { type: Object, required: false },
    selected: { type: Boolean, required: false }
  },
  data() {
    return {
      component: null
    };
  },
  methods: {
    onSelectPaymentAuth(data) {
      this.$emit("selectPaymentAuth", data);
    }
  },
  computed: {
    loader() {
      return () => import("./" + this.componentName);
    }
  },
  mounted() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {});
  }
};
</script>
